import { LorenzoMark } from "@/components/nav/LorenzoMark";

/* ============================================================
   Footer — markup + content ported 1:1 from lorenzolighting.com.
   Everything here (links, socials, contact details, copyright) is the
   exact content of that site's footer, per client requirement.
   ============================================================ */

const SOCIAL = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/lorenzo.lighting/",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" />
      </svg>
    ),
  },
  {
    label: "Youtube",
    href: "https://www.youtube.com/@LorenzoLighting",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <rect x="2.6" y="5.4" width="18.8" height="13.2" rx="4" stroke="currentColor" strokeWidth="1.6" />
        <path d="M10.3 9.4v5.2L14.9 12z" fill="currentColor" />
      </svg>
    ),
  },
  {
    label: "Linkedin",
    href: "https://www.linkedin.com/company/lorenzo-lighting",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M7.6 10.4v6.2M7.6 7.6v.1M11.4 16.6v-6.2M11.4 12.9c0-1.4.9-2.2 2.1-2.2s2.1.8 2.1 2.4v3.5"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/share/19NXZU5SYX/?mibextid=wwXIfr",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M14.6 8.4h-1.2c-.8 0-1.3.5-1.3 1.3v1.4h2.4l-.3 2.4h-2.1V21"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M9.9 11.1h2.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
];

const LIGHTING = "https://lorenzolighting.com";

/** Exact hrefs from the live https://lorenzolighting.com footer (2026-09-15). */
const FOOTER_LINKS = [
  { label: "Projects", href: "https://projects.lorenzolighting.com/projects" },
  { label: "Collections", href: `${LIGHTING}/collections/` },
  { label: "News", href: `${LIGHTING}/news/` },
  { label: "About Us", href: `${LIGHTING}/about/` },
];

const LEGAL_LINKS = [
  { label: "Legal & Terms", href: `${LIGHTING}/legal-terms` },
  { label: "Quality Policy", href: `${LIGHTING}/quality-policy` },
];

const CONTACT = {
  phone: "+971 50 735 0117",
  phoneHref: "tel:+971507350117",
  email: "info@lorenzolighting.com",
  address: "FF12, Art of Living Mall - Dubai - United Arab Emirates",
};

const COPYRIGHT = "2026 Lorenzo Creative. All rights reserved.";

const ICON_WHATSAPP = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <path
      d="M12 2.5a9.4 9.4 0 0 0-8.1 14.2L2.5 21.5l4.9-1.3A9.4 9.4 0 1 0 12 2.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M9 8.2c.2-.5.4-.5.7-.5h.5c.2 0 .4 0 .6.5l.7 1.6c.1.3 0 .5-.1.7l-.4.4c-.1.2-.2.3-.1.5.3.7 1.2 1.7 2.1 2.1.2.1.4 0 .5-.1l.4-.5c.2-.2.4-.2.6-.1l1.6.8c.3.1.4.3.4.5v.5c0 .4-.3.8-.7.9-.4.2-.9.2-1.4 0-1.1-.3-2.4-1-3.4-2-1-1-1.7-2.3-2-3.4-.2-.5-.2-1 0-1.4Z"
      fill="currentColor"
    />
  </svg>
);

const ICON_EMAIL = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <rect x="2.8" y="5" width="18.4" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="m3.5 6.5 8.5 6 8.5-6"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ICON_LOCATION = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <path
      d="M12 2.6c-3.6 0-6.5 2.9-6.5 6.5 0 4.6 5.7 11.3 6 11.6.3.3.7.3 1 0 .3-.3 6-7 6-11.6 0-3.6-2.9-6.5-6.5-6.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="9.1" r="2.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export function Footer() {
  return (
    <footer id="footer" className="site-footer">
      <div className="lz-container">
        <div className="footer__top">
          <div className="footer__brand">
            <a href={`${LIGHTING}/`} className="footer__logo" aria-label="Lorenzo">
              <span className="brand__mark">
                <LorenzoMark />
              </span>
            </a>

            <div className="footer__follow">
              <p className="footer__follow-label">Follow us</p>
              <div className="footer__social">
                {SOCIAL.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label={s.label}
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="footer__cols">
            <nav className="footer__links" aria-label="Footer">
              <ul>
                {FOOTER_LINKS.map((l) => (
                  <li key={l.href}>
                    <a href={l.href}>{l.label}</a>
                  </li>
                ))}
              </ul>
            </nav>

            <nav className="footer__links" aria-label="Legal">
              <ul>
                {LEGAL_LINKS.map((l) => (
                  <li key={l.href}>
                    <a href={l.href}>{l.label}</a>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="footer__cta">
              <p className="footer__cta-label">Have questions about our project?</p>
              <a className="btn--outline-light" href={`${LIGHTING}/#contact`}>
                Request Consultation
              </a>
            </div>

            <div className="footer__contact">
              <p className="footer__contact-label">Contact</p>

              <p className="footer__row">
                <span className="footer__row-icon">{ICON_WHATSAPP}</span>
                <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
              </p>

              <p className="footer__row">
                <span className="footer__row-icon">{ICON_EMAIL}</span>
                <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              </p>

              <p className="footer__row">
                <span className="footer__row-icon">{ICON_LOCATION}</span>
                <span>{CONTACT.address}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="footer__bottom">{COPYRIGHT}</div>
      </div>
    </footer>
  );
}
